import { amplitude, ga } from 'js/analytics/adapters'
import { baseWebEventProps } from 'js/analytics/standardizedProps'

type Props = {
  type: string
  code?: string
  category: string
}

// Call sites pass free-text categories ('Signup', 'Email login'). error_type is
// a low-cardinality bucket in the schema, so normalise to snake_case rather than
// sending both 'Email login' and 'email_login' as separate values.
const toErrorType = (category: string) =>
  category.trim().toLowerCase().replace(/\s+/g, '_')

export const trackErrorMessage = ({
  type: error_type,
  code: error_code,
  category: error_category,
}: Props) => {
  ga.track('Error', {
    error_code: error_code,
    error_type: error_type,
    error_category: error_category,
  })
  // The schema's only error event is system_error (same one
  // trackAuthenticationError uses): error_type carries the category bucket and
  // error_description the specific failure, with the code appended when present.
  amplitude.track('system_error', {
    ...baseWebEventProps(),
    action_type: 'inactive',
    error_type: toErrorType(error_category),
    error_description: error_code
      ? `${error_type} (${error_code})`
      : error_type,
  })
}
